(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@sm360/widget-commons-forms"), require("@sm360/widget-commons-core-services"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-vehicle"), require("react"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define("deposit", ["@sm360/widget-commons-forms", "@sm360/widget-commons-core-services", "@sm360/widget-commons-general", "@sm360/widget-commons-vehicle", "react", "_"], factory);
	else if(typeof exports === 'object')
		exports["deposit"] = factory(require("@sm360/widget-commons-forms"), require("@sm360/widget-commons-core-services"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-vehicle"), require("react"), require("lodash"));
	else
		root["Deposit"] = factory(root["CommonsForms"], root["CommonsCoreServices"], root["CommonsGeneral"], root["CommonsVehicle"], root["React"], root["_"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_vehicle__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_lodash__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/axios/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../node_modules/axios/lib/adapters/xhr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__("../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__("../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__("../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__("../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("../../node_modules/axios/lib/helpers/btoa.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__("../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__("../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/Cancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/CancelToken.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/isCancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/Axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__("../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__("../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../node_modules/axios/lib/core/InterceptorManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../node_modules/axios/lib/core/createError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/dispatchRequest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__("../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__("../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__("../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/enhanceError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/settle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/transformData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../node_modules/axios/lib/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__("../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/axios/lib/helpers/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/btoa.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/buildURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/combineURLs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/parseHeaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/spread.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__("../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "../../node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "../../node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("../../node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "../../node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("../../node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "../../node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./src/DepositProvider.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _Deposit = __webpack_require__("./src/components/Deposit/Deposit.jsx");

var _Deposit2 = _interopRequireDefault(_Deposit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DepositProvider = function (_React$Component) {
    _inherits(DepositProvider, _React$Component);

    function DepositProvider(props) {
        _classCallCheck(this, DepositProvider);

        var _this = _possibleConstructorReturn(this, (DepositProvider.__proto__ || Object.getPrototypeOf(DepositProvider)).call(this, props));

        _widgetCommonsCoreServices.ConfigsService.setOrganizationId(props.organizationId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitId(props.organizationUnitId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitLocation(props.organizationUnitLocation);
        _widgetCommonsCoreServices.ConfigsService.setWebsiteId(props.websiteId);
        _widgetCommonsCoreServices.ConfigsService.setLocation(props.location);

        _widgetCommonsCoreServices.LocaleService.setLocale(props.locale);
        _this.onUnload = _this.onUnload.bind(_this);
        return _this;
    }

    _createClass(DepositProvider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.addEventListener('beforeunload', this.onUnload);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.onUnload();
        }
    }, {
        key: 'onUnload',
        value: function onUnload() {
            _widgetCommonsGeneral.HistoryService.add(_widgetCommonsCoreServices.WindowProxy.location().href);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_Deposit2.default, { stripePublishableKey: this.props.stripePublishableKey, onSuccess: this.testFunction });
        }
    }]);

    return DepositProvider;
}(_react2.default.Component);

DepositProvider.propTypes = {
    locale: _react2.default.PropTypes.string.isRequired,
    websiteId: _react2.default.PropTypes.number.isRequired,
    organizationUnitId: _react2.default.PropTypes.number.isRequired,
    organizationId: _react2.default.PropTypes.number.isRequired,
    organizationUnitLocation: _react2.default.PropTypes.string.isRequired,
    location: _react2.default.PropTypes.string.isRequired,
    stripePublishableKey: _react2.default.PropTypes.string.isRequired
};

DepositProvider.displayName = 'DepositProvider';

exports.default = DepositProvider;

/***/ }),

/***/ "./src/components/AddressSection/AddressSection.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddressSection = function (_React$Component) {
    _inherits(AddressSection, _React$Component);

    function AddressSection() {
        _classCallCheck(this, AddressSection);

        return _possibleConstructorReturn(this, (AddressSection.__proto__ || Object.getPrototypeOf(AddressSection)).apply(this, arguments));
    }

    _createClass(AddressSection, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.provinces = (0, _lodash.orderBy)(_widgetCommonsForms.PROVINCES.map(function (option) {
                return {
                    value: option.code,
                    label: _widgetCommonsCoreServices.LocaleService.t(option.transKey)
                };
            }), ['value']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                contactValue = _props.contactValue,
                hasBeenSubmit = _props.hasBeenSubmit,
                handleFormGroupChange = _props.handleFormGroupChange;


            return _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'sr-text is-bold' },
                    _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.HOME_ADDRESS_SECTION_TITLE')
                ),
                _react2.default.createElement(_widgetCommonsForms.Groups.AddressGroup, {
                    values: contactValue,
                    labels: {
                        address: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.ADDRESS'),
                        address2: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.ADDRESS_2'),
                        city: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.CITY'),
                        postalCode: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.POSTAL_CODE'),
                        province: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.PROVINCE')
                    },
                    onChange: handleFormGroupChange,
                    provinces: this.provinces,
                    hasBeenSubmit: hasBeenSubmit
                })
            );
        }
    }]);

    return AddressSection;
}(_react2.default.Component);

AddressSection.propTypes = {
    contactValue: _propTypes2.default.string.isRequired,
    handleFormGroupChange: _propTypes2.default.func.isRequired,
    hasBeenSubmit: _propTypes2.default.bool.isRequired
};

AddressSection.displayName = 'AddressSection';

exports.default = AddressSection;

/***/ }),

/***/ "./src/components/CatchPhrase/CatchPhrase.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__("./src/components/CatchPhrase/CatchPhrase.scss");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatchPhrase = function CatchPhrase(_ref) {
    var depositAmount = _ref.depositAmount;

    var refundDisclaimer = _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.deposit', 'widget.deposit.refund.label') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.deposit', 'widget.deposit.refund.label').getValue() : _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.LIST_GARANTEE');

    return _react2.default.createElement(
        'div',
        { className: 'payment_infos_wrapper' },
        _react2.default.createElement(
            'h3',
            { className: 'sr-subtitle-2' },
            _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.TITLE', {
                amount: depositAmount
            })
        ),
        _react2.default.createElement(
            'ul',
            { className: 'payment_infos_wrapper--advantages-listing' },
            _react2.default.createElement(
                'li',
                { className: 'sr-text' },
                _react2.default.createElement('icon', { className: 'icon-Crochet is-util' }),
                ' ',
                _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.LIST_SECURITY'),
                _react2.default.createElement(
                    'a',
                    {
                        href: _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.PRIVACY_POLICY_URL'),
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        className: 'sr-link'
                    },
                    _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.PRIVACY_POLICY')
                )
            ),
            _react2.default.createElement(
                'li',
                { className: 'sr-text' },
                _react2.default.createElement('icon', { className: 'icon-Crochet is-util' }),
                refundDisclaimer
            )
        )
    );
};

CatchPhrase.propTypes = {
    depositAmount: _propTypes2.default.number.isRequired
};

CatchPhrase.displayName = 'CatchPhrase';

exports.default = CatchPhrase;

/***/ }),

/***/ "./src/components/CatchPhrase/CatchPhrase.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/CreditCard/CreditCard.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _calendarValues = __webpack_require__("./src/constants/calendarValues.js");

var Calendar = _interopRequireWildcard(_calendarValues);

var _errors = __webpack_require__("./src/constants/errors.js");

var _errors2 = _interopRequireDefault(_errors);

__webpack_require__("./src/components/CreditCard/CreditCard.scss");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Disable no-unused-prop-types for errors. Errors is ony used to show wich inputs has an error  */
/* eslint react/no-unused-prop-types: 1 */

var CreditCard = function (_React$Component) {
    _inherits(CreditCard, _React$Component);

    function CreditCard(props) {
        _classCallCheck(this, CreditCard);

        var _this = _possibleConstructorReturn(this, (CreditCard.__proto__ || Object.getPrototypeOf(CreditCard)).call(this, props));

        _this.state = {
            inputs: props.cardInfo,
            formValidation: {
                cardNumber: false,
                cvc: false,
                expiringMonth: false,
                expiringYear: false
            }
        };

        _this.handleDropdownChange = _this.handleDropdownChange.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.sendResponse = _this.sendResponse.bind(_this);

        _this.calendarYears = [];

        var actualYears = new Date().getFullYear();
        var j = void 0;
        for (j = actualYears; j < actualYears + 25; j += 1) {
            _this.calendarYears.push({ value: j, label: j });
        }
        return _this;
    }

    _createClass(CreditCard, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.sendResponse();

            this.calendarMonths = Calendar.CALENDAR_MONTHS.map(function (_ref) {
                var value = _ref.value,
                    transKey = _ref.transKey;
                return {
                    value: value,
                    label: _widgetCommonsCoreServices.LocaleService.t(transKey)
                };
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.errors.length) {
                var currentState = this.state;
                var error = nextProps.errors.find(function (mapError) {
                    return mapError.group === 'depositGroup';
                });
                var code = error ? error.code : null;

                if (code === _errors2.default.INCORRECT_NUMBER || code === _errors2.default.INVALID_NUMBER) {
                    currentState.formValidation.cardNumber = false;
                } else if (code === _errors2.default.INCORRECT_CVC || code === _errors2.default.INVALID_CVC) {
                    currentState.formValidation.cvc = false;
                } else if (code === _errors2.default.INVALID_EXPIRY_MONTH) {
                    currentState.formValidation.expiringMonth = false;
                } else if (code === _errors2.default.INVALID_EXPIRY_YEAR) {
                    currentState.formValidation.expiringYear = false;
                }

                this.setState(currentState);
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            return !(0, _lodash.isEqual)(this.props.cardInfo, nextProps.cardInfo);
        }
    }, {
        key: 'handleDropdownChange',
        value: function handleDropdownChange(option, inputName) {
            var _this2 = this;

            var state = this.state;

            state.inputs[inputName] = option.value;
            state.formValidation[inputName] = true;

            this.setState(state, function () {
                _this2.sendResponse();
            });
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(value, name) {
            var _this3 = this;

            var formValidation = this.state.formValidation;
            var inputs = this.state.inputs;
            inputs[name] = value;
            formValidation[name] = _widgetCommonsForms.ValidationService.validateIsNotEmpty(value);

            if (name === 'cardNumber') {
                formValidation.cardNumber = _widgetCommonsForms.ValidationService.validateCardNumber(value);
            } else {
                formValidation.cvc = _widgetCommonsForms.ValidationService.validateCardValidationCode(value);
            }

            this.setState({
                inputs: inputs,
                formValidation: formValidation
            }, function () {
                _this3.sendResponse();
            });
        }
    }, {
        key: 'sendResponse',
        value: function sendResponse() {
            var areFieldsValid = _widgetCommonsForms.ValidationService.validateForm(this.state.formValidation);

            var groupResponse = _widgetCommonsForms.GroupResponseService.createResponse(areFieldsValid, this.state.inputs, 'error.group.deposit', null, 'depositGroup');

            this.props.onChange(groupResponse);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'section',
                { className: 'CreditCard__wrapper' },
                _react2.default.createElement(
                    'label',
                    { className: 'sr-text is-bold' },
                    _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.FORM_TITLE')
                ),
                _react2.default.createElement(_widgetCommonsForms.InputText, {
                    label: _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.CARD_NUMBER'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.CARD_NUMBER'),
                    name: 'cardNumber',
                    type: 'tel',
                    classNames: ['styled-placeholder double-third'],
                    value: this.state.inputs.cardNumber,
                    isValid: this.state.formValidation.cardNumber,
                    isRequired: true,
                    valueChange: this.handleInputChange,
                    hasBeenSubmit: this.props.hasBeenSubmit,
                    minLength: _widgetCommonsForms.FIELD_LENGTH.CREDIT_CARD_MIN,
                    maxLength: _widgetCommonsForms.FIELD_LENGTH.CREDIT_CARD_MAX
                }),
                _react2.default.createElement(_widgetCommonsForms.InputText, {
                    label: _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.SECURITY_CODE'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.SECURITY_CODE'),
                    name: 'cvc',
                    type: 'tel',
                    classNames: ['styled-placeholder third'],
                    value: this.state.inputs.cvc,
                    isValid: this.state.formValidation.cvc,
                    isRequired: true,
                    valueChange: this.handleInputChange,
                    hasBeenSubmit: this.props.hasBeenSubmit,
                    minLength: _widgetCommonsForms.FIELD_LENGTH.SECURITY_CODE_MIN,
                    maxLength: _widgetCommonsForms.FIELD_LENGTH.SECURITY_CODE_MAX
                }),
                _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                    name: 'expiringMonth',
                    value: this.state.inputs.expiringMonth,
                    options: this.calendarMonths,
                    placeholder: _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.EXPIRATION_MONTH'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.EXPIRATION_MONTH'),
                    classNames: ['input-dropdown third'],
                    hasBeenSubmit: this.props.hasBeenSubmit,
                    isRequired: true,
                    valueChange: this.handleDropdownChange
                }),
                _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                    name: 'expiringYear',
                    value: this.state.inputs.expiringYear,
                    placeholder: _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.EXPIRATION_YEAR'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.EXPIRATION_YEAR'),
                    options: this.calendarYears,
                    classNames: ['input-dropdown third'],
                    hasBeenSubmit: this.props.hasBeenSubmit,
                    isRequired: true,
                    valueChange: this.handleDropdownChange
                })
            );
        }
    }]);

    return CreditCard;
}(_react2.default.Component);

CreditCard.defaultProps = {
    errors: [],
    hasBeenSubmit: false
};

CreditCard.propTypes = {
    onChange: _react.PropTypes.func.isRequired,
    cardInfo: _react.PropTypes.shape({
        cardNumber: _react.PropTypes.string.isRequired,
        cvc: _react.PropTypes.string.isRequired,
        expiringYear: _react.PropTypes.string.isRequired,
        expiringMonth: _react.PropTypes.string.isRequired
    }).isRequired,
    errors: _react.PropTypes.arrayOf(_react2.default.PropTypes.shape({
        code: _react.PropTypes.string.isRequired,
        message: _react.PropTypes.string.isRequired
    })),
    hasBeenSubmit: _react.PropTypes.bool
};

CreditCard.displayName = 'CreditCard';

exports.default = CreditCard;

/***/ }),

/***/ "./src/components/CreditCard/CreditCard.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/Deposit/Deposit.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _lodash = __webpack_require__("lodash");

var _DepositForm = __webpack_require__("./src/components/DepositForm/DepositForm.jsx");

var _DepositForm2 = _interopRequireDefault(_DepositForm);

var _StripeAPIService = __webpack_require__("./src/services/StripeAPIService/StripeAPIService.js");

var _StripeAPIService2 = _interopRequireDefault(_StripeAPIService);

var _DepositAPIService = __webpack_require__("./src/services/DepositAPIService/DepositAPIService.js");

var _DepositAPIService2 = _interopRequireDefault(_DepositAPIService);

var _errors = __webpack_require__("./src/constants/errors.js");

var _errors2 = _interopRequireDefault(_errors);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Deposit = function (_React$Component) {
    _inherits(Deposit, _React$Component);

    function Deposit(props) {
        _classCallCheck(this, Deposit);

        var _this = _possibleConstructorReturn(this, (Deposit.__proto__ || Object.getPrototypeOf(Deposit)).call(this, props));

        _this.state = {
            shownErrors: [],
            hasBeenSubmit: false
        };

        _widgetCommonsCoreServices.LocaleService.loadTranslations({ en: _en2.default, fr: _fr2.default });
        _widgetCommonsCoreServices.LocaleService.loadTranslations(_widgetCommonsForms.Translations);

        _this.createStripeToken = _this.createStripeToken.bind(_this);
        _this.stripeResponseHandler = _this.stripeResponseHandler.bind(_this);
        return _this;
    }

    _createClass(Deposit, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();

            if (windowProxy) {
                var script = windowProxy.document.createElement('script');

                var promise = new Promise(function (resolve, reject) {
                    script.async = true;
                    script.src = 'https://js.stripe.com/v2/';
                    script.addEventListener('load', resolve);
                    script.addEventListener('error', function () {
                        return reject('Error loading script.');
                    });
                    script.addEventListener('abort', function () {
                        return reject('Script loading aborted.');
                    });
                    windowProxy.document.head.appendChild(script);
                });

                promise.then(function () {
                    _widgetCommonsCoreServices.WindowProxy.get().Stripe.setPublishableKey(_this2.props.stripePublishableKey);
                });
            }
        }
    }, {
        key: 'createStripeToken',
        value: function createStripeToken(formState) {
            var _this3 = this;

            this.setState({
                hasBeenSubmit: true,
                shownErrors: formState.errors
            });

            if (!_widgetCommonsForms.ValidationService.validateForm(formState.formValidation)) {
                return;
            }

            this.setState({
                account: formState.contact
            }, function () {
                _this3.props.lockScreen();
                _StripeAPIService2.default.createToken(formState.cardInfo, formState.contact, _this3.stripeResponseHandler);
            });
        }
    }, {
        key: 'handleStripeError',
        value: function handleStripeError(error) {
            var errors = [].concat(_toConsumableArray(this.state.shownErrors));
            var errorMessage = _errors2.default[error.code] || _errors2.default['error.default'];
            errors.push({
                message: _widgetCommonsCoreServices.LocaleService.t(errorMessage),
                code: error.code,
                group: 'depositGroup'
            });

            this.setState({
                shownErrors: (0, _lodash.uniqBy)(errors, 'code')
            });

            this.props.lockScreen();
        }
    }, {
        key: 'stripeResponseHandler',
        value: function stripeResponseHandler(status, stripeResponse) {
            var _this4 = this;

            this.setState({
                shownErrors: []
            });
            if (stripeResponse.error) {
                this.handleStripeError(stripeResponse.error);
                return;
            }

            if (this.props.quote.vehicle.getIsVehicleNew()) {
                _widgetCommonsGeneral.AnalyticsService.eventDataLayer('form|deposit-new', 'submit', 'deposit-showroom');
            } else {
                _widgetCommonsGeneral.AnalyticsService.eventDataLayer('form|deposit-used', 'submit', 'deposit-showroom');
            }

            _DepositAPIService2.default.createDeposit(this.props.quote, stripeResponse.id, this.state.account).then(function (showroomQuote) {
                _this4.props.onSuccess(showroomQuote, _this4.state.account);
                _this4.props.lockScreen();
            }).catch(function () {
                _this4.setState({
                    shownErrors: [{
                        message: _widgetCommonsCoreServices.LocaleService.t(_errors2.default['error.payment']),
                        code: 'error.payment',
                        group: 'depositAPI'
                    }]
                });
                _this4.props.lockScreen();
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var errorBlock = !!this.state.shownErrors.length && _react2.default.createElement(_widgetCommonsForms.ErrorsHandler, { errors: this.state.shownErrors });

            return _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                errorBlock,
                _react2.default.createElement(_DepositForm2.default, {
                    account: this.props.account,
                    buttonConf: this.props.buttonConf,
                    onClick: this.createStripeToken,
                    depositAmount: this.props.depositAmount,
                    hasError: !!this.state.shownErrors.length,
                    errorMessage: this.state.shownErrors,
                    hasBeenSubmit: this.state.hasBeenSubmit
                })
            );
        }
    }]);

    return Deposit;
}(_react2.default.Component);

Deposit.defaultProps = {
    account: new _widgetCommonsGeneral.Account(),
    buttonConf: {
        label: _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.BUTTON_TITLE'),
        icon: null
    },
    quote: new _widgetCommonsVehicle.Quote.QuoteModel(),
    lockScreen: function lockScreen() {},
    depositAmount: 500
};

Deposit.propTypes = {
    account: _react.PropTypes.instanceOf(_widgetCommonsGeneral.Account),
    onSuccess: _react.PropTypes.func.isRequired,
    quote: _react.PropTypes.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel),
    stripePublishableKey: _react.PropTypes.string.isRequired,
    buttonConf: _react.PropTypes.shape({
        label: _react.PropTypes.string,
        icon: _react.PropTypes.string
    }),
    lockScreen: _react.PropTypes.func,
    depositAmount: _react.PropTypes.number
};

Deposit.displayName = 'Deposit';

exports.default = Deposit;

/***/ }),

/***/ "./src/components/DepositForm/DepositForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _AddressSection = __webpack_require__("./src/components/AddressSection/AddressSection.jsx");

var _AddressSection2 = _interopRequireDefault(_AddressSection);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _CatchPhrase = __webpack_require__("./src/components/CatchPhrase/CatchPhrase.jsx");

var _CatchPhrase2 = _interopRequireDefault(_CatchPhrase);

var _CreditCard = __webpack_require__("./src/components/CreditCard/CreditCard.jsx");

var _CreditCard2 = _interopRequireDefault(_CreditCard);

var _IndentitySection = __webpack_require__("./src/components/IndentitySection/IndentitySection.jsx");

var _IndentitySection2 = _interopRequireDefault(_IndentitySection);

__webpack_require__("./src/components/DepositForm/DepositForm.scss");

var _errors = __webpack_require__("./src/constants/errors.js");

var _errors2 = _interopRequireDefault(_errors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DepositForm = function (_React$Component) {
    _inherits(DepositForm, _React$Component);

    function DepositForm(props) {
        _classCallCheck(this, DepositForm);

        var _this = _possibleConstructorReturn(this, (DepositForm.__proto__ || Object.getPrototypeOf(DepositForm)).call(this, props));

        _this.state = {
            contact: _extends({}, props.account, {
                phoneNumber: props.account.homePhone,
                email: props.account.email1
            }),
            cardInfo: {
                cardNumber: '',
                cvc: '',
                expiringYear: '',
                expiringMonth: ''
            },
            formValidation: {},
            errors: [],
            isButtonDisable: true
        };

        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleFormGroupChange = _this.handleFormGroupChange.bind(_this);
        return _this;
    }

    _createClass(DepositForm, [{
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
        }
    }, {
        key: 'handleFormGroupChange',
        value: function handleFormGroupChange(groupResponse) {
            var nexState = this.state;
            var isValid = groupResponse.valid;
            var value = groupResponse.value,
                name = groupResponse.name;


            nexState.formValidation[name] = isValid;

            if (name === 'identityGroup' || name === 'addressGroup') {
                nexState.contact = _extends({}, this.state.contact, value);
                nexState.contact.email1 = value.email || nexState.contact.email1;
                nexState.contact.homePhone = value.phoneNumber || nexState.contact.homePhone;
                nexState.contact.address = value.address || nexState.contact.address;
                nexState.contact.address2 = value.address2 || nexState.contact.address2;
                nexState.contact.city = value.city || nexState.contact.city;
                nexState.contact.postalCode = value.postalCode || nexState.contact.postalCode;
                nexState.contact.province = value.province || nexState.contact.province;
            } else {
                nexState.cardInfo = _extends({}, nexState.cardInfo, value);
            }

            if (isValid) {
                var errorIndex = nexState.errors.findIndex(function (error) {
                    return error.group === name;
                });

                if (errorIndex !== -1) {
                    nexState.errors.splice(errorIndex, 1);
                }
            } else {
                var createError = nexState.errors.findIndex(function (error) {
                    return error.group === name;
                }) === -1;

                if (createError) {
                    nexState.errors.push({
                        code: groupResponse.error.code,
                        group: name,
                        message: _widgetCommonsCoreServices.LocaleService.t(_errors2.default[groupResponse.error.code])
                    });
                }
            }

            this.setState(_extends({}, nexState, {
                isButtonDisable: !_widgetCommonsForms.ValidationService.validateForm(nexState.formValidation)
            }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var imagesServer = _index2.default.source.image;
            var buttonConf = this.props.buttonConf;

            var buttonClasses = ['sr-button-1 is-small'];
            var buttonIcon = buttonConf.icon && _react2.default.createElement('icon', { className: buttonConf.icon });
            var errorMessage = this.props.hasError && this.props.errorMessage.length > 0 ? this.props.errorMessage.map(function (message) {
                return message.message;
            }) : [];
            var errorMessageDisplay = _react2.default.createElement('p', { className: 'error-forms', dangerouslySetInnerHTML: { __html: errorMessage.join('<br/>') } });

            return _react2.default.createElement(
                'form',
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'deposit__inner-content has-primary-background' },
                    _react2.default.createElement(_IndentitySection2.default, {
                        contactValue: this.state.contact,
                        hasBeenSubmit: this.props.hasBeenSubmit,
                        handleFormGroupChange: this.handleFormGroupChange
                    }),
                    _react2.default.createElement(_AddressSection2.default, {
                        contactValue: this.state.contact,
                        hasBeenSubmit: this.props.hasBeenSubmit,
                        handleFormGroupChange: this.handleFormGroupChange
                    }),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(
                        'section',
                        { className: 'deposit__credit-card-container' },
                        _react2.default.createElement(
                            'h1',
                            { className: 'sr-title-1' },
                            _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.DEPOSIT_TITLE')
                        ),
                        _react2.default.createElement(_CatchPhrase2.default, { depositAmount: this.props.depositAmount }),
                        _react2.default.createElement('img', {
                            src: imagesServer + '/images/widget/showroom/asset/credit-cards.png',
                            alt: _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.IMG_ALT')
                        }),
                        _react2.default.createElement(_CreditCard2.default, {
                            onChange: this.handleFormGroupChange,
                            cardInfo: this.state.cardInfo,
                            errors: this.state.errors,
                            depositAmount: this.props.depositAmount,
                            hasBeenSubmit: this.props.hasBeenSubmit
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'deposit-next-btn-section' },
                        errorMessageDisplay,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: buttonClasses.join(' '),
                                onClick: function onClick() {
                                    return _this2.props.onClick(_this2.state);
                                }
                            },
                            buttonConf.label,
                            buttonIcon
                        )
                    )
                )
            );
        }
    }]);

    return DepositForm;
}(_react2.default.Component);

DepositForm.defaultProps = {
    hasError: false,
    hasBeenSubmit: false,
    errorMessage: ''
};

DepositForm.propTypes = {
    account: _react.PropTypes.instanceOf(_widgetCommonsGeneral.Account).isRequired,
    onClick: _react.PropTypes.func.isRequired,
    buttonConf: _react.PropTypes.shape({
        label: _react.PropTypes.string,
        icon: _react.PropTypes.string
    }).isRequired,
    depositAmount: _react.PropTypes.number.isRequired,
    hasError: _react.PropTypes.bool,
    hasBeenSubmit: _react.PropTypes.bool,
    errorMessage: _react.PropTypes.string
};

DepositForm.displayName = 'DepositForm';

exports.default = DepositForm;

/***/ }),

/***/ "./src/components/DepositForm/DepositForm.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/DepositState/DepositState.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

__webpack_require__("./src/components/DepositState/DepositState.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DepositState = function DepositState(_ref) {
    var depositAmount = _ref.depositAmount,
        emailAdress = _ref.emailAdress;

    return _react2.default.createElement(
        'div',
        { className: 'deposit-state--wrapper' },
        _react2.default.createElement(
            'div',
            { className: 'deposit-state--icon' },
            _react2.default.createElement('icon', { className: 'icon-Crochet' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'deposit-state--content' },
            _react2.default.createElement(
                'p',
                { className: 'deposit-state--title sr-text is-bold' },
                _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.STATE.CONGRATS')
            ),
            _react2.default.createElement(
                'p',
                { className: 'deposit-state--subtitle sr-text is-bold' },
                _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.STATE.TITLE', {
                    amount: depositAmount
                })
            ),
            _react2.default.createElement(
                'p',
                { className: 'deposit-state--content-text' },
                _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.STATE.CONTENT', {
                    email: emailAdress
                })
            )
        )
    );
};

DepositState.defaultProps = {
    depositAmount: 500
};

DepositState.propTypes = {
    depositAmount: _propTypes2.default.number,
    emailAdress: _propTypes2.default.string.isRequired
};

DepositState.displayName = 'DepositState';

exports.default = DepositState;

/***/ }),

/***/ "./src/components/DepositState/DepositState.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/IndentitySection/IndentitySection.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndentitySection = function IndentitySection(_ref) {
    var contactValue = _ref.contactValue,
        hasBeenSubmit = _ref.hasBeenSubmit,
        handleFormGroupChange = _ref.handleFormGroupChange;

    return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
            'label',
            { className: 'sr-text is-bold' },
            _widgetCommonsCoreServices.LocaleService.t('DEPOSIT.PERSONAL_INFOS_SECTION_TITLE')
        ),
        _react2.default.createElement(_widgetCommonsForms.Groups.IdentityGroup, {
            values: contactValue,
            labels: {
                firstname: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.FIRSTNAME'),
                lastname: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.LASTNAME'),
                phoneNumber: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.PHONE_NUMBER'),
                email: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.CONTACT.EMAIL')
            },
            hasBeenSubmit: hasBeenSubmit,
            onChange: handleFormGroupChange
        })
    );
};

IndentitySection.propTypes = {
    contactValue: _propTypes2.default.string.isRequired,
    hasBeenSubmit: _propTypes2.default.bool.isRequired,
    handleFormGroupChange: _propTypes2.default.func.isRequired
};

IndentitySection.displayName = 'IndentitySection';

exports.default = IndentitySection;

/***/ }),

/***/ "./src/config/dev.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://service.backbones.widget-supplier.dev.office.n360.io","account":"https://service.backbones.account.dev.office.n360.io/api","showroom":"https://dev-api.showroom360.ca:9443","graphql":"https://service.backbones.webauto-supplier.dev.office.n360.io/webauto/graphql"},"source":{"image":"http://img-dev.sm360.ca","widget":"https://service.backbones.widget-supplier.dev.office.n360.io/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-dev-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-dev-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dev = __webpack_require__("./src/config/dev.json");

var _dev2 = _interopRequireDefault(_dev);

var _int = __webpack_require__("./src/config/int.json");

var _int2 = _interopRequireDefault(_int);

var _local = __webpack_require__("./src/config/local.json");

var _local2 = _interopRequireDefault(_local);

var _prod = __webpack_require__("./src/config/prod.json");

var _prod2 = _interopRequireDefault(_prod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

if (true) {
    config = _prod2.default;
} else if (process.env.BUILD_ENV === 'development') {
    config = _dev2.default;
} else if (process.env.BUILD_ENV === 'integration') {
    config = _int2.default;
} else {
    config = _local2.default;
}

exports.default = _extends({}, config);

/***/ }),

/***/ "./src/config/int.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/local.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-api-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"http://localhost:3360/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/prod.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget.sm360.ca","account":"https://account.sm360.ca/api","showroom":"https://api.showroom360.ca","graphql":"https://webauto-supplier-api.sm360.ca/webauto/graphql"},"source":{"image":"https://img.sm360.ca","widget":"https://widget.sm360.ca/client"},"secureCookies":true,"sentry":{"url":"","sentryLevel":"WARNING","consoleLevel":"ERROR","whitelistUrls":["^.*(widgets-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/constants/calendarValues.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CALENDAR_MONTHS = exports.CALENDAR_MONTHS = [{ value: 1, transKey: 'DEPOSIT.CALENDAR_MONTHS.JANUARY' }, { value: 2, transKey: 'DEPOSIT.CALENDAR_MONTHS.FEBRUARY' }, { value: 3, transKey: 'DEPOSIT.CALENDAR_MONTHS.MARCH' }, { value: 4, transKey: 'DEPOSIT.CALENDAR_MONTHS.APRIL' }, { value: 5, transKey: 'DEPOSIT.CALENDAR_MONTHS.MAY' }, { value: 6, transKey: 'DEPOSIT.CALENDAR_MONTHS.JUNE' }, { value: 7, transKey: 'DEPOSIT.CALENDAR_MONTHS.JULY' }, { value: 8, transKey: 'DEPOSIT.CALENDAR_MONTHS.AUGUST' }, { value: 9, transKey: 'DEPOSIT.CALENDAR_MONTHS.SEPTEMBER' }, { value: 10, transKey: 'DEPOSIT.CALENDAR_MONTHS.OCTOBER' }, { value: 11, transKey: 'DEPOSIT.CALENDAR_MONTHS.NOVEMBER' }, { value: 12, transKey: 'DEPOSIT.CALENDAR_MONTHS.DECEMBER' }];

exports.default = {
    CALENDAR_MONTHS: CALENDAR_MONTHS
};

/***/ }),

/***/ "./src/constants/errors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'error.default': 'CANT_PROCESS',
    'error.payment': 'DEPOSIT.ERRORS.DURING_PAYMENT',
    'error.creditcard.declined': 'DEPOSIT.ERRORS.CREDIT_CARD_DECLINED',
    'error.invalid.postalCode': 'DEPOSIT.ERRORS.INVALID_POSTAL_CODE',
    'error.vehicle.alreadyLocked': 'DEPOSIT.ERRORS.VEHICLE_ALREADY_LOCKED',
    'error.group.address': 'DEPOSIT.ERRORS.ADDRESS_GROUP',
    'error.group.deposit': 'DEPOSIT.ERRORS.DEPOSIT_GROUP',
    'error.group.identity': 'DEPOSIT.ERRORS.IDENTITY_GROUP',
    invalid_cvc: 'DEPOSIT.ERRORS.INVALID_CVC',
    incorrect_cvc: 'DEPOSIT.ERRORS.INCORRECT_CVC',
    incorrect_number: 'DEPOSIT.ERRORS.INCORRECT_NUMBER',
    invalid_number: 'DEPOSIT.ERRORS.INVALID_NUMBER',
    invalid_expiry_month: 'DEPOSIT.ERRORS.INVALID_EXPIRY_MONTH',
    invalid_expiry_year: 'DEPOSIT.ERRORS.INVALID_EXPIRY_YEAR'
};

/***/ }),

/***/ "./src/constants/vehicleTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var INVENTORY = exports.INVENTORY = 'inventory';
var CATALOG = exports.CATALOG = 'catalog';

exports.default = {
    INVENTORY: INVENTORY,
    CATALOG: CATALOG
};

/***/ }),

/***/ "./src/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"DEPOSIT":{"CALENDAR_MONTHS":{"JANUARY":"January","FEBRUARY":"February","MARCH":"March","APRIL":"April","MAY":"May","JUNE":"June","JULY":"July","AUGUST":"August","SEPTEMBER":"September","OCTOBER":"October","NOVEMBER":"November","DECEMBER":"December"},"ERRORS":{"CANT_PROCESS":"Your deposit request can't be sent. Please contact Dealership customer service for more informations.","ADDRESS_GROUP":"Looks like there's a problem with your home address.","CREDIT_CARD_DECLINED":"Your card was declined.","DEPOSIT_GROUP":"Looks like there's a problem with some payment information.","DURING_PAYMENT":"There was an error processing your deposit. Please contact Dealership customer service for more informations.","IDENTITY_GROUP":"Looks like there's a problem with your personal infos.","VEHICLE_ALREADY_LOCKED":"This vehicle is already locked.","INCORRECT_NUMBER":"Card number is incorrect","INVALID_CVC":"CVC number is invalid","INCORRECT_CVC":"CVC number is incorrect","INVALID_NUMBER":"Card number is invalid","INVALID_EXPIRY_MONTH":"Invalid expiry month","INVALID_EXPIRY_YEAR":"Invalid expiry year"},"HOME_ADDRESS_SECTION_TITLE":"Home Address","PAYMENT_INFOS_SECTION":{"BUTTON_TITLE":"Secure Your vehicle","CARD_NUMBER":"Card Number","EXPIRATION_MONTH":"Expiration Month","EXPIRATION_YEAR":"Expiration Year","FORM_TITLE":"Enter Payment Details","IMG_ALT":"Credit cards","LIST_SECURITY":"Your information will be processed securely and in accordance with our ","PRIVACY_POLICY":"Privacy Policy","PRIVACY_POLICY_URL":"/en/privacy-policy","LIST_GARANTEE":"5 Days Money-Back Guarantee / Refundable deposit","SECURITY_CODE":"Security Code","TITLE":"Make a $%{amount} Deposit and Reserve Your Vehicle"},"GENERALS_FORMS":{"NEXT":"Next","CANCEL":"Cancel","RESERVE":"Reserve Now","BACK_TO_VEHICLE":"Back to My Vehicle"},"STATE":{"CONGRATS":"Congrats!","TITLE":"Your $%{amount} Deposit Has Been Received Successfully","CONTENT":"We will contact you shortly to schedule an appointment. Your reservation confimation has been sent to %{email}"},"NAV":{"RESERVE_NOW":"Reserve It Now","RESERVED":"Reserved","STEP1":"1. Info Review","STEP2":"2. Reserve It","STEP3":"3. Confirmation"},"PERSONAL_INFOS_SECTION_TITLE":"Contact Information","DEPOSIT_TITLE":"Deposit"}}

/***/ }),

/***/ "./src/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"DEPOSIT":{"CALENDAR_MONTHS":{"JANUARY":"Janvier","FEBRUARY":"Février","MARCH":"Mars","APRIL":"Avril","MAY":"Mai","JUNE":"Juin","JULY":"Juillet","AUGUST":"Août","SEPTEMBER":"Septembre","OCTOBER":"Octobre","NOVEMBER":"Novembre","DECEMBER":"Décembre"},"ERRORS":{"CANT_PROCESS":"Votre dépôt n'a pu être envoyé. Contactez le service à la clientèle pour plus de détails.","ADDRESS_GROUP":"Il semble y avoir un problème avec votre adresse résidentielle.","CREDIT_CARD_DECLINED":"Votre carte a été refusée.","DEPOSIT_GROUP":"Il semble y avoir un problème avec les informations de paiement.","DURING_PAYMENT":"Un problème est survenu lors de l'envoi de votre dépôt. Contactez le service à la clientèle pour plus de détails.","IDENTITY_GROUP":"Il semble y avoir un problème avec vos données personnelles.","INVALID_POSTAL_CODE":"Votre code postal est invalide.","PROTECTION_UNKNOWN_ERROR":"Une erreur inconnue est survenue. Veuillez réessayer","VEHICLE_ALREADY_LOCKED":"Ce véhicule est déjà réservé.","INCORRECT_NUMBER":"Numéro de carte de crédit incorrect","INVALID_CVC":"Numéro de CVC invalide","INCORRECT_CVC":"Numéro de CVC incorrect","INVALID_NUMBER":"Numéro de carte de crédit est invalide","INVALID_EXPIRY_MONTH":"Mois d'expiration est invalide","INVALID_EXPIRY_YEAR":"Année d'expiration est invalide"},"HOME_ADDRESS_SECTION_TITLE":"Adresse du domicile","PAYMENT_INFOS_SECTION":{"BUTTON_TITLE":"Réserver votre voiture","CARD_NUMBER":"Numéro de carte","EXPIRATION_MONTH":"Mois d'expiration","EXPIRATION_YEAR":"Année d'expiration","FORM_TITLE":"Entrez vos informations de paiement","IMG_ALT":"Carte de crédit","LIST_SECURITY":"Vos informations personnelles seront traitées en toute sécurité et conformément à notre ","PRIVACY_POLICY":"politique de confidentialité","PRIVACY_POLICY_URL":"/fr/politique-confidentialite","LIST_GARANTEE":"Garantie de remboursement de 5 jours / dépôt remboursable","SECURITY_CODE":"Code de sécurité","TITLE":"Faites un dépôt de %{amount}$ et réservez votre véhicule"},"GENERALS_FORMS":{"NEXT":"Suivant","CANCEL":"Annulé","RESERVE":"Reserver Maintenant","BACK_TO_VEHICLE":"Retour à mon véhicule"},"STATE":{"CONGRATS":"Félicitations!","TITLE":"Votre dépôt de $%{amount} a été complété avec succès.","CONTENT":"Nous vous contacterons sous peut pour schéduler un rendez-vous. Votre confirmation de réservation à été envoyé à %{email}"},"NAV":{"RESERVE_NOW":"Reserver le maintenant","RESERVED":"Reservé","STEP1":"1. Résumer","STEP2":"2. Reservé le","STEP3":"3. Confirmation"},"PERSONAL_INFOS_SECTION_TITLE":"Coordonnées","DEPOSIT_TITLE":"Dépôt"}}

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.widgets = exports.ERRORS = exports.DepositAPIService = exports.StripeAPIService = exports.IndentitySection = exports.DepositState = exports.CreditCard = exports.CatchPhrase = exports.AddressSection = exports.Translations = undefined;

var _Deposit = __webpack_require__("./src/components/Deposit/Deposit.jsx");

var _Deposit2 = _interopRequireDefault(_Deposit);

var _AddressSection = __webpack_require__("./src/components/AddressSection/AddressSection.jsx");

var _AddressSection2 = _interopRequireDefault(_AddressSection);

var _CatchPhrase = __webpack_require__("./src/components/CatchPhrase/CatchPhrase.jsx");

var _CatchPhrase2 = _interopRequireDefault(_CatchPhrase);

var _CreditCard = __webpack_require__("./src/components/CreditCard/CreditCard.jsx");

var _CreditCard2 = _interopRequireDefault(_CreditCard);

var _DepositState = __webpack_require__("./src/components/DepositState/DepositState.jsx");

var _DepositState2 = _interopRequireDefault(_DepositState);

var _IndentitySection = __webpack_require__("./src/components/IndentitySection/IndentitySection.jsx");

var _IndentitySection2 = _interopRequireDefault(_IndentitySection);

var _errors = __webpack_require__("./src/constants/errors.js");

var _errors2 = _interopRequireDefault(_errors);

var _DepositProvider = __webpack_require__("./src/DepositProvider.jsx");

var _DepositProvider2 = _interopRequireDefault(_DepositProvider);

var _StripeAPIService = __webpack_require__("./src/services/StripeAPIService/StripeAPIService.js");

var _StripeAPIService2 = _interopRequireDefault(_StripeAPIService);

var _DepositAPIService = __webpack_require__("./src/services/DepositAPIService/DepositAPIService.js");

var _DepositAPIService2 = _interopRequireDefault(_DepositAPIService);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = _Deposit2.default;
var provider = _DepositProvider2.default;
var main = provider;
var Translations = {
    en: _en2.default,
    fr: _fr2.default
};

exports.Translations = Translations;
exports.AddressSection = _AddressSection2.default;
exports.CatchPhrase = _CatchPhrase2.default;
exports.CreditCard = _CreditCard2.default;
exports.DepositState = _DepositState2.default;
exports.IndentitySection = _IndentitySection2.default;
exports.StripeAPIService = _StripeAPIService2.default;
exports.DepositAPIService = _DepositAPIService2.default;
exports.ERRORS = _errors2.default;
var widgets = exports.widgets = {
    Translations: Translations,
    Deposit: {
        components: {
            root: root,
            provider: provider,
            main: main
        }
    }
};

exports.default = {
    root: root,
    provider: provider,
    Translations: Translations,
    Deposit: main,
    AddressSection: _AddressSection2.default,
    CatchPhrase: _CatchPhrase2.default,
    CreditCard: _CreditCard2.default,
    DepositState: _DepositState2.default,
    IndentitySection: _IndentitySection2.default,
    StripeAPIService: _StripeAPIService2.default,
    DepositAPIService: _DepositAPIService2.default,
    ERRORS: _errors2.default
};

/***/ }),

/***/ "./src/services/DepositAPIService/DepositAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _vehicleTypes = __webpack_require__("./src/constants/vehicleTypes.js");

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DepositAPIService = function () {
    function DepositAPIService() {
        _classCallCheck(this, DepositAPIService);
    }

    _createClass(DepositAPIService, [{
        key: 'createDeposit',
        value: function createDeposit(quote, stripeToken, contactInfo) {
            var trackedPageCookie = _widgetCommonsGeneral.CookieService.getToken('primary-tracked-page');
            var adgearUidCookie = _widgetCommonsGeneral.CookieService.getToken('aguid');

            var url = _index2.default.endpoint.widget + '/widgets/deposits';
            var axiosConfig = {
                headers: { locale: _widgetCommonsCoreServices.LocaleService.getLocale().replace('-', '_') }
            };
            var isInventoryVehicle = quote.vehicle.vehicleId > 0 || Number.parseInt(quote.vehicleId, 10) > 0;

            var deliveryCreationRequest = {
                deliveryCreation: {
                    websiteId: _widgetCommonsCoreServices.ConfigsService.getWebsiteId(),
                    vehicleInventoryId: quote.vehicle.vehicleId || quote.vehicleId,
                    vehicleType: isInventoryVehicle ? _vehicleTypes.INVENTORY : _vehicleTypes.CATALOG,
                    quote: quote.getShowroomQuote(),
                    quoteId: quote.id,
                    stripeToken: stripeToken,
                    layoutWebsiteLocation: 'showroom.checkout.responsive',
                    evaluationQuestionsValue: null,
                    tradeIns: quote.tradeIns,
                    contactInfo: contactInfo
                },
                primaryTrackedPage: null,
                adgearUid: null
            };

            if (trackedPageCookie) {
                try {
                    deliveryCreationRequest.primaryTrackedPage = JSON.parse(trackedPageCookie.replace(/\\/g, ''));
                } catch (e) {
                    throw e;
                }
            }

            if (adgearUidCookie) {
                deliveryCreationRequest.adgearUid = adgearUidCookie;
            }
            return _axios2.default.post(url, deliveryCreationRequest, axiosConfig).then(function (response) {
                var depositQuote = _widgetCommonsVehicle.Quote.QuoteService.resetQuoteDepositLead(quote, response.data);
                _widgetCommonsGeneral.ShiftDigitalService.createFormEvent(response.data.leadId, 'Deposit | Showroom');
                return _widgetCommonsVehicle.ShowroomService.saveQuote(depositQuote.getShowroomQuote(), false).then(function (showroomQuote) {
                    var newQuote = _widgetCommonsVehicle.Quote.QuoteService.resetQuoteFromShowroomSave(depositQuote, showroomQuote);

                    return Promise.resolve(newQuote);
                });
            });
        }
    }]);

    return DepositAPIService;
}();

exports.default = new DepositAPIService();

/***/ }),

/***/ "./src/services/StripeAPIService/StripeAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StripeAPIService = function () {
    function StripeAPIService() {
        _classCallCheck(this, StripeAPIService);
    }

    _createClass(StripeAPIService, [{
        key: 'createToken',
        value: function createToken(cardInfo, contactInfo, stripeResponseHandler) {
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();

            if (windowProxy) {
                windowProxy.Stripe.card.createToken({
                    number: cardInfo.cardNumber,
                    cvc: cardInfo.cvc,
                    exp_year: cardInfo.expiringYear,
                    exp_month: cardInfo.expiringMonth,
                    name: contactInfo.firstname + ' ' + contactInfo.lastname,
                    address_line1: contactInfo.address,
                    address_city: contactInfo.city,
                    address_state: contactInfo.province,
                    address_zip: contactInfo.postalCode
                }, stripeResponseHandler);
            }
        }
    }]);

    return StripeAPIService;
}();

exports.default = new StripeAPIService();

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.js");


/***/ }),

/***/ "@sm360/widget-commons-core-services":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__;

/***/ }),

/***/ "@sm360/widget-commons-forms":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__;

/***/ }),

/***/ "@sm360/widget-commons-general":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__;

/***/ }),

/***/ "@sm360/widget-commons-vehicle":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_vehicle__;

/***/ }),

/***/ "lodash":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_lodash__;

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// widget-6.25.3.min.js